<template>
    <div>
        <el-form label-position="right" ref="form" :validate-on-rule-change="false" label-width="120px">
            <el-row class="bottom20">
                <el-row class="column-name" justify="start">
                    <span>基本信息</span>
                </el-row>
                <el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="合同名称" prop="contractId">
                                <el-input :value="billDetail.contractName" disabled size="mini">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="客户" prop="customerId">
                                <el-input :value="billDetail.customerName" disabled size="mini">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="月份" prop="month">
                                <el-input :value="billDetail.yearMonth" disabled size="mini">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="系统金额(元)" prop="month" v-if="hisAmountShow()">
                                <el-input :value="formatCurrency(formatBigDecimal(billDetail.hisAmount))" disabled size="mini">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
        </el-form>

        <el-row class="bottom20">
            <el-row class="column-name" justify="start">
                <span>计费信息</span>
            </el-row>
            <el-row>
                <el-table :data="billDetail.incomes" :show-summary="false" :summary-method="getSummaries">
                    <template #append>
                        <div class="summary">
                            <div style="flex:1">总价</div>
                            <div style="flex:1"> </div>
                            <div style="flex:1"> </div>
                            <div style="flex:1">
                                <span>{{ getComesTotalPrice('current', 'incomes') }}</span>
                                <span class="old-data">{{ getComesTotalPrice('confirm', 'incomes') }}</span>
                            </div>
                        </div>
                    </template>
                    <el-table-column property="name" label="计费项">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.contractBillAdjustId == null ? scope.row.contractItemName : scope.row.contractBillAdjustReason}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="description" label="数据中心/设备编号">
                        <template slot-scope="scope">
                            <div>
                                <div v-if="scope.row.records != null && scope.row.records.length > 0">
                                    <div v-for="record in scope.row.records" :key="record.resourceTag">
                                        {{record.resourceTag}}
                                    </div>
                                </div>
                                <div v-else>
                                    {{scope.row.roomNames | roomNamesString}}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="usageAmount" label="使用量">
                        <template slot-scope="scope">
                            <div>
                                <div v-if="scope.row.records != null && scope.row.records.length > 0">
                                    <div v-for="record in scope.row.records" :key="record.resourceTag">
                                        {{formatBigDecimal(record.usageAmount)}}({{scope.row.calculateUnit}})
                                    </div>
                                </div>
                                <div v-else>
                                    <el-input-number v-model="scope.row.usageAmount" :min="0" @change="usageAmountChange(scope.row)"
                                                     v-if="usageAmountEditable(scope.row)"
                                                     size="mini">
                                    </el-input-number>
                                    <span v-else>
                                        {{formatBigDecimal(scope.row.usageAmount)}}
                                    </span>
                                    ({{scope.row.calculateUnit}})
                                    <span class="old-data" v-if="scope.row.usageAmount && diffList.length > 0 ">(原：{{ getOldData(scope.row, 'usageAmount') }})</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="fee" label="费用">
                        <template slot-scope="scope">
                            <div>
                                <el-input-number v-model="scope.row.fee" :min="0" :precision="2" :step="0.01" size="mini"
                                                 v-if="feeEditable(scope.row)">
                                </el-input-number>
                                <span v-else>
                                    {{formatBigDecimal(scope.row.fee) | athub_currency}}
                                </span>
                                (元)
                                <span class="old-data" v-if="scope.row.fee && diffList.length > 0 ">(原：{{ getOldData(scope.row, 'fee') }}元)</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-row>

        <el-row class="bottom20" v-if="billDetail.outcomes != null && billDetail.outcomes.length > 0">
            <el-row class="column-name" justify="start">
                <span>特殊成本</span>
            </el-row>
            <el-row>
                <el-table :data="billDetail.outcomes" :show-summary="false" :summary-method="getSummaries">
                    <template #append>
                        <div class="summary">
                            <div style="flex:1">总价</div>
                            <div style="flex:1"> </div>
                            <div style="flex:1"> </div>
                            <div style="flex:1">
                                <span>{{ getComesTotalPrice('current', 'outcomes') }}</span>
                                <span class="old-data">{{ getComesTotalPrice('confirm', 'outcomes') }}</span>
                            </div>
                        </div>
                    </template>
                    <el-table-column property="name" label="计费项">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.contractBillAdjustId == null ? scope.row.contractItemName : scope.row.contractBillAdjustReason}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="description" label="数据中心/设备编号">
                        <template slot-scope="scope">
                            <div>
                                <div v-if="scope.row.records != null && scope.row.records.length > 0">
                                    <div v-for="record in scope.row.records" :key="record.resourceTag">
                                        {{record.resourceTag}}
                                    </div>
                                </div>
                                <div v-else>
                                    {{scope.row.roomNames | roomNamesString}}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="usageAmount" label="使用量">
                        <template slot-scope="scope">
                            <div>
                                <div v-if="scope.row.records != null && scope.row.records.length > 0">
                                    <div v-for="record in scope.row.records" :key="record.resourceTag">
                                        {{formatBigDecimal(record.usageAmount)}}({{scope.row.calculateUnit}})
                                    </div>
                                </div>
                                <div v-else>
                                    <span>
                                        {{formatBigDecimal(scope.row.usageAmount)}}
                                    </span>
                                    ({{scope.row.calculateUnit}})
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="fee" label="费用">
                        <template slot-scope="scope">
                            <div>
                                {{formatBigDecimal(scope.row.fee) | athub_currency}}
                                (元)
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-row>
        <el-row v-if="billDetail.id != null">
            <el-row class="column-name" justify="start">
                <span>流转信息</span>
            </el-row>
            <el-row>
                <workflow
                    ref="workflowHistory"
                    bussiness="CONTRACTBILL"
                    :use-new-api="true"
                    :bussinessId="billDetail.id"
                    @loaded="afterLoadWorkflowHistory"
                ></workflow>
            </el-row>
        </el-row>
        
        <attachment
            ownerTable='CONTRACTBILL'
            docType='CONTRACTBILL'
            :ownerId='billDetail.id'
            :existed="billDetail.id != null"
            :addable="isCanAddAttachment" :is-can-delete-file="isCanDeleteFile"
            @afterAttachDownloadFunc="afterAttachDownloadFunc"
        >
        </attachment>
    </div>
</template>

<script>
    import Emitter from 'element-ui/src/mixins/emitter'
    import BillingServer from '@/api/billing'
    import Attachment from "@/components/attachment"
    // import ContractBillFlowAdd from '../flow/contract.bill.flow.add'
    // import ContractBillFlowAccordion from '../flow/contract.bill.flow.accordion'
    import Workflow from "@/components/workflow"
    import {
        deepDiffBetweenObjects,
    } from "../../../contract/contract.common";
    import _ from 'lodash'
    import {
        COMPONENT_DETAIL,
        formatCurrency,
        OPERATION_DETAIL_ADD,
        OPERATION_DETAIL_EDIT,
        OPERATION_DETAIL_SHOW,
    } from "./contract.bill.month.common";

    export default {
        name: COMPONENT_DETAIL,
        componentName: COMPONENT_DETAIL,
        mixins: [Emitter],
        components: {Attachment, Workflow},
        inject: ['listQuery'],
        data() {
            return {
                operation: null,
                id: null,
                billDetail: {
                    contractName: null,
                    customerName: null,
                    yearMonth: null,
                    incomes: [],
                    outcomes: [],
                },
                confirmedBillDetail: null,
                workflowNodeLogs: null,
                attachmentLoaded: false,
                attachments: null,
                diffList: []
            };
        },
        watch: {
            operation: {
                handler() {
                    this.$emit('operation-change', this.operation);
                }
            }
        },
        computed: {
            isCanAddAttachment() {
                return this.billDetail != null && this.billDetail.id != null && !['CONFIRMED', 'WAPPRNEW', 'WAPPRCHA'].includes(this.billDetail.workflowStatus);
            },
            contractBillFlowAccordionShow() {
                return this.id != null;
            },
            contractBillFlowAddShow() {
                return this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT;
            },
        },
        methods: {
            getOldData(data, key) {
                const row = this.diffList.find(d => d.uniqueKey === `${data.contractItemId || ''}${data.contractItemName || ''}`)
                if(row) {
                    return row[key]
                }
                return ''
            },
            has(obj, attr) {
                return _.has(obj, attr)
            },
            afterAttachDownloadFunc(files) {
                this.attachmentLoaded = true;
                this.attachments = files;
            },
            isCanDeleteFile(file) {
                return this.billDetail != null && this.billDetail.id != null && !['CONFIRMED', 'WAPPRNEW', 'WAPPRCHA'].includes(this.billDetail.workflowStatus)
            },
            look(id) {
                this.toShow(this.billDetail);
                this.$nextTick(() => {
                this.reloadWorkflowHistory();
                });
            },
            reloadWorkflowHistory() {
                // 工作流
                this.afterLoadWorkflowHistory(null);
                if (this.$refs.workflowHistory != null) {
                this.$refs.workflowHistory.getHistoryList();
                }
            },
            afterLoadWorkflowHistory(workflowNodeLogs) {
                let _workflowNodeLogs = workflowNodeLogs == null ? null : JSON.parse(JSON.stringify(workflowNodeLogs));
                this.workflowNodeLogs = _workflowNodeLogs;
                this.$emit('afterLoadWorkflowHistory', _workflowNodeLogs);
            },
            hisAmountShow() {
                return this.operation === OPERATION_DETAIL_SHOW;
            },
            usageAmountEditable(row) {
                return (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT) &&
                    row.billingType === 'INCOME' && (row.billingContent === 'RENT' || row.billingContent === 'IDLE')
            },
            feeEditable(row) {
                return (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT) && row != null;
            },
            usageAmountChange(row) {
                row.usageAmount = row.usageAmount == null ? 0 : row.usageAmount;
                row.fee = Math.round(row.usageAmount * row.contractItemRate * 100) / 100;
            },
            getComesTotalPrice(type = 'current', fieldName = 'incomes') {
                let comes = []
                if(type === 'current') {
                    if(!this.billDetail || (this.billDetail && this.billDetail[fieldName].length === 0))
                    return null
                    comes = this.billDetail[fieldName]
                } else {
                    if(!this.confirmedBillDetail || (this.confirmedBillDetail && this.confirmedBillDetail[fieldName].length === 0) || this.diffList.length === 0)
                    return null
                    comes = this.confirmedBillDetail[fieldName]
                }
                let text = '-（元）'
                let total = comes.reduce((prev, cur) => {
                    const value = Number(cur.fee);
                        if (!isNaN(value)) {
                            return prev + cur.fee;
                        } else {
                            return prev;
                        }
                }, 0)
                text = type === 'current' ? `${formatCurrency(total)}（元）` : `(原：${formatCurrency(total)}元)`
                return text
            },
            getSummaries(param) {
                const { columns, data } = param;
                const summaries = [];
                columns.forEach((column, index) => {
                    let text;
                    if (column.property === 'name') {
                        text = '总价';
                    } else if (column.property === 'fee') {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            let total = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                            const diffTotal = this.getIncomesTotalPrice() 
                            
                            text = diffTotal ? `${formatCurrency(total)}（元）` + diffTotal : `${formatCurrency(total)}（元）`;

                        } else {
                            text = '-（元）';
                        }
                    } else {
                        text = '';
                    }
                  
                    summaries[index] = text;
                });

                return summaries;
            },
            async toShow(data) {
                let res = await BillingServer.contractBillMonth.get(data.id, {loading: true});
                let res1 = await BillingServer.contractBillMonth.getConfirmedContractBillMonth(data.id, {loading: true});
                this.diffList = []
                if (res.data.success) {
                    if (this.id === res.data.data.id) {
                        let contractBillFlowAccordion = this.getContractBillFlowAccordion();
                        if (contractBillFlowAccordion != null) {
                            await contractBillFlowAccordion.loadFlows();
                        }
                    } else {
                        this.id = res.data.data.id;
                    }
                    this.billDetail = res.data.data;
                    this.$emit('curDetail', this.billDetail)
                    this.$emit('curConfirmedDetail', res1.data.data)
                }
                const oldIncomes = res1.data.data.incomes
                this.confirmedBillDetail = res1.data.data
                const incomes = res.data.data.incomes
                const diff = deepDiffBetweenObjects(oldIncomes, incomes, function(item) {
                    return `${item.contractItemId || ''}${item.contractItemName || ''}`
                })
                this.diffList = diff
                this.operation = OPERATION_DETAIL_SHOW;
            },
            async calculateBillDetail(contractId, yearMonth, contractBillId) {
                let billDetail = null;
                try {
                    let res = await BillingServer.contractBillMonth.calculateBillDetail(contractId, yearMonth, contractBillId,
                        {loading: true});
                    if (res.data.success) {
                        billDetail = res.data.data;
                        this.$emit('curDetail', billDetail)
                    }
                } catch (e) {
                    return Promise.reject(e);
                }
                return Promise.resolve(billDetail);
            },
            getContractBillFlowAdd() {
              return this.$refs['contractBillFlowAdd'];
            },
            getContractBillFlowAccordion() {
              return this.$refs['contractBillFlowAccordion'];
            },
            async toAdd({contractId, month}) {
                this.id = null;
                this.billDetail = await this.calculateBillDetail(contractId, month);
                // await this.getContractBillFlowAdd().initFormModel();
                this.operation = OPERATION_DETAIL_ADD;
            },
            async toEdit({id, contractId, month}) {
                this.id = id;
                this.billDetail = await this.calculateBillDetail(contractId, month, id);
                // await this.getContractBillFlowAdd().initFormModel();
                this.operation = OPERATION_DETAIL_EDIT;
            },
            async saveAdd() {
                // let flow = await this.getContractBillFlowAdd().getToSubmitFormModel();
                let data = this.billDetail;
                // data.flow = flow;
                let res = await BillingServer.contractBillMonth.add(data, {loading: true});
                if (res.data.success) {
                    this.$message.success('保存成功！');
                    this.toShow(res.data.data);
                    this.listQuery();
                } else {
                    this.$message.error(res.data.responseMessage);
                }
            },
            async saveEdit() {
                // let flow = await this.getContractBillFlowAdd().getToSubmitFormModel();
                let data = this.billDetail;
                data.id = this.id;
                // data.flow = flow;
                let res = await BillingServer.contractBillMonth.update(this.id, data, {loading: true});
                if (res.data.success) {
                    this.$message.success('保存成功！');
                    this.toShow(res.data.data);
                    this.listQuery();
                } else {
                    this.$message.error(res.data.responseMessage);
                }
            },
            formatBigDecimal(value) {
                return value == null || value === 0 ? '-' : value;
            },
            formatCurrency(value, currency, decimals) {
                return formatCurrency(value, currency, decimals);
            },
        },
        filters: {
            roomNamesString(roomNames) {
                return roomNames == null ? '' : roomNames.join(',');
            },
            athub_currency(value, currency, decimals) {
                return formatCurrency(value, currency, decimals);
            }
        }
    }
</script>

<style scoped>
.old-data {
    line-height: 40px;
    color: #e6a23c;
    margin-left: 4px;
}
.summary {
    background-color: #F5F7FA;
    color: #606266;
    padding: 12px 0;
    padding-left: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
</style>
